import React, { Component } from 'react';

import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import './Streams.css'

class Video extends Component {
  timeout = null;
  pipGranted = false;

  constructor(props) {
    super(props);

    this.pipLeft = () => this.pipLeave();
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.currentSpeaker != nextProps.currentSpeaker) return true;
    if (!this.refs.stream || !this.refs.stream.srcObject) return true;

    if (nextProps.stream && this.refs.stream.srcObject && nextProps.stream.id != this.refs.stream.srcObject.id) {
      return true;
    }
    
    if (!nextProps.stream) {
      return true;
    }

    if (this.refs.stream && nextProps.pip && !this.props.pip) {
      if (document.pictureInPictureElement) { document.exitPictureInPicture() }

      this.refs.stream.removeEventListener('leavepictureinpicture', this.pipLeft);
      this.refs.stream.requestPictureInPicture()
      .then(_ => {
        this.pipGranted = true;
        this.refs.stream.addEventListener('leavepictureinpicture', this.pipLeft);
        this.refs.stream.setAttribute('data-pipped', 'pipped');
      })
      .catch(e => {
        console.log("PIP denied");
        this.pipGranted = false;
      });
    }

    return false;
  }

  pipLeave() {
    this.props.onLeavePip();
    if (this.refs.stream) this.refs.stream.setAttribute('data-pipped', 'none');
  }

  componentDidMount() {
    this.refs.stream.addEventListener('playing', () => {
      if (this.refs.stream) this.refs.stream.setAttribute('data-orientation', this.refs.stream.videoWidth > this.refs.stream.videoHeight ? 'landscape' : 'portrait');
    });
  }

  componentDidUpdate() {
    console.log("Received props");
    let nextProps = this.props;

    if (!this.props.stream) {
      clearTimeout(this.timeout);
      return;
    }

    let setStream = () => {
      let currentStream = this.refs.stream.srcObject;
      this.refs.stream.srcObject = nextProps.stream;

      if (this.props.muted) {
        this.refs.stream.setAttribute('muted', this.props.muted);
      }
      else {
        this.refs.stream.removeAttribute('muted');
      }
      this.refs.stream.setAttribute('playsinline', '1');
      this.refs.stream.setAttribute('autoplay', '1');

      let id = nextProps.stream.getVideoTracks().length ? nextProps.stream.getVideoTracks()[0].id : 'no tracks';
      console.log(this.props.className, "Reading", id);

      const playPromise = this.refs.stream.play();
      if (playPromise !== undefined) {
        playPromise.catch(error => {
          console.log("ERROR", id, error);
        });
      }

      nextProps.stream.onaddtrack = (e) => {
        console.log("Stream track added", e);
      };

      console.log("Added stream", nextProps.stream);

      if (this.refs.stream && this.props.currentSpeaker) {
        this.refs.stream.setSinkId(this.props.currentSpeaker);
      }
    }

    setStream();

    if (this.timeout !== null) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }

    this.timeout = setTimeout(() => {
      if (this.refs.stream && this.refs.stream.currentTime == 0) {
        // revert to stream before
        console.log("Not playing");
        this.props.onError();
      }
    }, 2000);

    window.stream = this.refs.stream.srcObject;
  }

  render() {
    const _props = Object.assign({}, this.props);
    delete _props.currentSpeaker;
    delete _props.pip;
    delete _props.onLeavePip;
    return (<video {..._props} ref="stream" playsInline></video>);
  }
};

class Streams extends Component {
  pipBigScreen = false;

  state = {
    big: false,
    zoomed: false,
    additionalVideoStreams: {},
    pip: null
  }

  setBigScreen(kind) {
    this.setState({big: kind});
  }

  getBigScreen() {
    const streamsOnline = this.getStreamsOnline();

    if (streamsOnline.length == 2) {
      if (this.state.big) {
        return this.state.big;
      }
      else {
        return 'remote';
      }
    }
    else if (streamsOnline.length == 1) {
      if (this.props.remoteStream) return 'remote';
      else if (this.props.localStream) return 'local';
    }
    else {
      return false;
    }
  }

  getStreamsOnline() {
    return [this.props.remoteStream, this.props.localStream].filter(r => !!r);
  }

  toggleZoom() {
    this.setState({
      zoomed: !this.state.zoomed
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.callStatus !== 'established' && this.getStreamsOnline().length === 2) {
      this.props.onStreamsRunning();
    }

    if (this.props.remoteStream) {
      const additionalVideoStreams = this.state.additionalVideoStreams;
      const tracks = this.props.remoteStream.getVideoTracks();
      tracks.forEach((v, ix) => {
        if (ix === 0) return;
        const track = v;
        if (!(track.id in this.state.additionalVideoStreams)) {
          additionalVideoStreams[track.id] = new MediaStream();
          additionalVideoStreams[track.id].addTrack(v);

          this.setState({
            additionalVideoStreams: additionalVideoStreams,
          });

          setTimeout(() => {
            this.setBigScreen(additionalVideoStreams[track.id].id);
          }, 32);
        }
      });

      const trackIds = tracks.map(t => t.id);
      Object.keys(additionalVideoStreams).forEach(tid => {
        if (trackIds.indexOf(tid) === -1) {
          const stream = additionalVideoStreams[tid];
          delete additionalVideoStreams[tid];
          
          this.setState({
            additionalVideoStreams: additionalVideoStreams,
          });

          if (this.getBigScreen() === stream.id) {
            if (this.props.remoteStream) {
              this.setBigScreen('remote');
            }
            else {
              this.setBigScreen('local');
            }
          }
        }
      });
    }
  }
  
  setPip(e, s) {
    this.pipBigScreen = false;
    e.stopPropagation();
    if (this.state.pip === s.id) {
      if (document.pictureInPictureElement) { document.exitPictureInPicture() }
    }
    this.setState({pip: this.state.pip === s.id ? null : s.id});
  }

  render() {
    let hasPip = 'pictureInPictureEnabled' in document;
    const mainScreen = this.getBigScreen();

    return (
      <div className={
          "streams"
          + (this.props.remoteStream ? ' hasremotestream' : '')
          + (this.props.localStream ? ' haslocalstream' : '')
          + (this.state.zoomed ? ' zoomed' : '')
        }>
          {mainScreen && this.props.remoteStream && <div
            className={"remoteStreamContainer" + (mainScreen == 'remote' ? ' bigStream' : ' smallStream')}
            onClick={() => mainScreen == 'remote' ? this.toggleZoom() : this.setBigScreen('remote')}
          >
            <div className="streamoptions"><div className="contactname"><span>{this.props.remote.name}</span></div><div className="actions">{hasPip && <div className="icon" onClick={(e) => this.setPip(e, this.props.remoteStream)}><OpenInNewIcon fill='white' /></div>}</div></div>
            <Video onLeavePip={() => this.setState({pip: null})} pip={this.state.pip === this.props.remoteStream.id} currentSpeaker={this.props.currentSpeaker} className="remoteStream" stream={this.props.remoteStream} onError={() => this.props.onError('remote')} />
          </div>}
          {mainScreen && Object.values(this.state.additionalVideoStreams).map(s => {
            return (<div
              key={s.id}
              className={"remoteStreamContainer" + (mainScreen === s.id ? ' bigStream' : ' smallStream')}
              onClick={() => mainScreen === s.id ? this.toggleZoom() : this.setBigScreen(s.id)}
            >
              <div className="streamoptions"><div className="contactname"><span>Screen</span></div><div className="actions">{hasPip && <div className="icon" onClick={(e) => this.setPip(e, s)}><OpenInNewIcon fill='white' /></div>}</div></div>
              <Video onLeavePip={() => this.setState({pip: null})} pip={this.state.pip === s.id} currentSpeaker={this.props.currentSpeaker} className="remoteStream" muted={true} stream={s} onError={() => this.props.onError('remote')} />
            </div>);
          })}
          {mainScreen && this.props.localStream && <div className={"localStreamContainer" + (mainScreen == 'local' ? ' bigStream' : ' smallStream')}
            onClick={() => mainScreen == 'local' ? this.toggleZoom() : this.setBigScreen('local')}
          >
            <div className="streamoptions"><div className="contactname"><span>{this.props.localName}</span></div><div className="actions">{hasPip && <div className="icon" onClick={(e) => this.setPip(e, this.props.localStream)}><OpenInNewIcon fill='white' /></div>}</div></div>
            <Video onLeavePip={() => this.setState({pip: null})} pip={this.state.pip === this.props.localStream.id} currentSpeaker={this.props.currentSpeaker} className="localStream" stream={this.props.localStream} muted={true} onError={() => this.props.onError('local')} />
          </div>}
      </div>
    )
  }
};

export default Streams;


// WEBPACK FOOTER //
// ./src/shared/Streams.js


// WEBPACK FOOTER //
// ./src/shared/Streams.js